import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';

import { SessionStorageService } from 'src/app/services/session-storage.service';
import { LoggingMessageService } from 'src/app/services/logging-message.service';
import { AuthService } from 'src/app/services/auth.service';
import { UserNavigationService } from 'src/app/services/user-navigation.service';
import { DomSanitizer } from '@angular/platform-browser';
import { WindowEventsService } from 'src/app/services/window-events.service';
import { IframeService } from 'src/app/services/iframe.service';
import { BaseWebsiteComponent } from '../base-website/base-website.component';
import { PendoService } from 'src/app/services/pendo.service';
import { pairwise, startWith } from 'rxjs/operators';
import { SubscriptionChangeService } from 'src/app/services/subscription-change.service';

@Component({
  standalone: true,
  selector: 'app-system-dashboard',
  templateUrl: './system-dashboard.component.html',
  styleUrls: ['./system-dashboard.component.scss']
})

export class SystemDashboardComponent
extends BaseWebsiteComponent
implements OnInit, OnDestroy {

    constructor(
        public router: Router,
        public route: ActivatedRoute,
        public logger: LoggingMessageService,
        public sessionService: SessionStorageService,
        public navigationService: UserNavigationService,
        public authService: AuthService,
        public windowEvents: WindowEventsService,
        public iframeService: IframeService,
        public pendoService: PendoService,
        public sanitizer: DomSanitizer,
        public subscriptionService: SubscriptionChangeService) {

            super(router, route, logger, sessionService, navigationService, authService, windowEvents, iframeService, pendoService, sanitizer, subscriptionService);
    }

    ngOnInit() {
        super.ngOnInit();
        this.selectedSubscriptionID = this.subscriptionService.SelectedSubscription; this.subscriptionService.AvailableSubscriptionsString,
        this.availableSubscriptions = this.subscriptionService.AvailableSubscriptionsString;
    }

    subscribeToChildSiteEvents() {
        this.subscribePortalLogin();
        this.subscribePortalLogout();
        this.subscribePortalActionEvents();
        this.subscribeSubDomainActionEvents();
        this.subscribeToPreviousValue();
    }

    getIframeReferences() {
        if (!this.visibleIframe) {
            this.visibleIframe = document.getElementById('appSystemManagementIFrame') as HTMLIFrameElement;
        }
    }

    loadIframe(path: string) {
        const loggedIn = this.authService.isUserLoggedIn();
        if ((loggedIn === true) && (path !== '/login')) {
            const displayedMenu = this.navigationService.DisplayedNavigationMenu;
            if (displayedMenu && displayedMenu.Items && displayedMenu.Items.length > 0) {
                this.setIframeSource(path);
                this.checkAccessToken(path);
                this.iframeService.setSysManagementFrameVisibility(true);
                this.iframeService.setLinkId('');
            }
        } else {
            this.setIframeSourceWithLogin(path);
        }
    }

    setIframeSource(path: string) {
        const iframe = this.visibleIframe;
        if (iframe) {
            path = path.replace('/if/sysdashboard/', '');
            const user = this.authService.getUser();
            this.logger.debug('sys-dashboard', 'setIframeSource', this.selectedSubscriptionID , this.availableSubscriptions ,`Src: ${path}`, '');
            this.currentUrl = path;
            this.iframeService.setSysManagementFrameSource(path);
            this.navigationService.emitNavigationComplete(this.linkid);
        }
    }

    private subscribeToPreviousValue() {
        const prevSubscription = this.iframeService.sysMngSource$.pipe(
            startWith(this.currentUrl),
            pairwise())
            .subscribe(([previousValue, currentValue]) => {
                this.previousUrl = previousValue;
            });
        this.$subscriptions.add(prevSubscription);
    }

    ngOnDestroy(): void {
        this.visibleIframe = null;
        this.iframeService.setSysManagementFrameVisibility(false);
        super.ngOnDestroy();
    }
}
